module.exports = __webpack_public_path__ + "fonts/Poppins-SemiBold.342ba3d8.ttf";